export default __webpack_public_path__ + "static/media/apple.f265a9c0.png";